<template>
  <div>
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
        :size="size"
      >
        <el-form-item label="工单来源">
          <el-select v-model="filters.orderSource" clearable placeholder="请选择工单来源" @visible-change="handleVisibleChange">
            <el-option
              v-for="item in orderSourceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filters.status" clearable placeholder="请选择订单状态" @visible-change="handleVisibleChange">
            <el-option
              v-for="item in orderStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单编号">
          <el-input v-model="filters.orderNo"
                    clearable
                    placeholder="请填写工单编号"></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-search" label="查询" type="primary" @click="onSubmit" />
        </el-form-item>
      </el-form>
      <div class="filtersposition"></div>
    </el-scrollbar>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        @expand-change="expandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="处理结果：">
                <span class="height40">{{ props.row.statusText }}</span>
              </el-form-item>
              <el-form-item label="工单来源：">
                <span class="height40">{{ props.row.orderSourceText }}</span>
              </el-form-item>
              <el-form-item label="工单编号：">
                <span class="height40">{{ props.row.orderNo }}</span>
              </el-form-item>
              <el-form-item label="客户姓名：">
                <span class="height40">{{ props.row.oldmanName }}</span>
              </el-form-item>
              <el-form-item label="联系方式：">
                <span class="height40">{{ props.row.userPhone }}</span>
              </el-form-item>
              <el-form-item label="服务地址：">
                <span class="height40">{{ props.row.detailedAddress }}</span>
              </el-form-item>
              <el-form-item label="服务站：">
                <span class="height40">{{ props.row.merchantName }}</span>
              </el-form-item>
              <el-form-item label="服务人员：">
                <span v-if="props.row.orderStatus==2" class="height40"></span>
                <span v-else-if="props.row.changeNameGet==''" class="height40">{{ props.row.userNameGet }}</span>
                <span v-else class="height40">{{props.row.changeNameGet}}</span>
              </el-form-item>
              <el-form-item label="服务项目：">
                <span class="height40">{{ goodsItemText }}</span>
              </el-form-item>
              <el-form-item label="金额：">
                <span class="height40">{{ goodsItemPrice }}元</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <!-- <el-table-column label="序号" align="center" min-width="80">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column> -->
        <el-table-column prop="orderSourceText" label="工单来源" min-width="120" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="工单编号" min-width="180" align="center"></el-table-column>
        <el-table-column prop="oldmanName" label="客户姓名" min-width="150" align="center"></el-table-column>
        <el-table-column prop="serviceSecondLevelName" label="服务项目" min-width="150" align="center"></el-table-column>
        <!-- <el-table-column label="序号" align="center" min-width="80">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="statusText" label="处理结果" min-width="120" align="center"></el-table-column>
        <el-table-column prop="orderSourceText" label="工单来源" min-width="120" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="工单编号" min-width="180" align="center"></el-table-column>
        <el-table-column prop="oldmanName" label="客户姓名" min-width="150" align="center"></el-table-column> -->
        <el-table-column label="服务人员" min-width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus==2" class="height40"></span>
            <span v-else-if="scope.row.changeNameGet==''" class="height40">{{ scope.row.userNameGet }}</span>
            <span v-else class="height40">{{scope.row.changeNameGet}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="服务状态" min-width="120" align="center"></el-table-column>
        <el-table-column label="操作" min-width="200" align="center">
          <template slot-scope="scope">
            <div style="display:flex;">
              <el-button
                :disabled="scope.row.orderStatus!=1"
                class="el-icon-document"
                size="small"
                type="success"
                @click="handlesure(scope.row)"
              >确认</el-button>
              <el-button
                :disabled="scope.row.status!=1 && scope.row.status!=2"
                class="el-icon-delete"
                size="small"
                type="danger"
                @click="handleCancel(scope.row)"
              >取消</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
  components: { KtButton },
  data() {
    return {
      size: "medium",
      orderSourceList: [
        { label: "app下单", value: 1 },
        { label: "平台下单", value: 2 },
        { label: "政府下单", value: 3 }
      ], //工单的来源

      orderStatusList: [
        { label: "待接单", value: 1 },
        { label: "商家已确认", value: 2 },
        { label: "已接单", value: 3 },
        { label: "服务完成", value: 4 },
        { label: "已撤单", value: 5 }
      ], //订单的状态

      filters: {
        orderSource: "",
        status: "",
        orderNo: ''
      },
      goodsItemText: "", //购买商品的回显数据
      goodsItemPrice: 0, //购买商品的价格回显数据
      tableData: [],
      expands: [], //表格展开的id集合
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      total: 0, //数据的总数,
      groupId: "", //机构id
      merchantId: "" //商家id
    };
  },
  methods: {
    /* 
      查询按钮查询
    */
    onSubmit() {
      this.queryList((this.pageNum = 1), (this.pageSize = 10));
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryList((this.pageNum = 1), (this.pageSize = 10));
      }
    },

    /* 
      确认订单
    */
    handlesure(row) {
      this.$confirm("是否确认订单?", "确认订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.$postJson(`omc/serviceOrder/ensure/${row.id}`).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    /* 
      取消派单
    */
    handleCancel(row) {
      console.log(row);
      this.$confirm("是否确认取消服务订单?", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: "true",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.$postJson(`omc/serviceOrder/retreat/${row.id}`).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.queryList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    /* 
      获取表格展开的id
    */
    getRowKeys: function(row) {
      return row.id;
    },

    /* 
      展开和关闭表格的事件
    */
    expandChange(row, expandedRows) {
      console.log(row, expandedRows, "defiiefigi");
      this.queryMerchantDetail(row.id);
      if (expandedRows.length) {
        this.expands = [];
        if (row) {
          this.expands.push(row.id);
        }
      } else {
        this.expands = [];
      }
    },

    /* 
      分页查询列表
    */
    queryList() {
      let params = new Object();
      params.groupId = this.groupId;
      params.merchantId = this.merchantId;
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      params.orderSource = this.filters.orderSource;
      if(this.filters.status!=""){
        if(this.filters.status == "3"){
            params.statusList= [3,6,7];
        }else if(this.filters.status == "4"){
            params.statusList= [4,8];
        }else{
          params.statusList= [this.filters.status];
        }
      }
      if(this.filters.orderNo){
        params.orderNo = this.filters.orderNo
      }
      this.$postJson("omc/serviceOrder/listPage", params).then(res => {
        console.log(res, "列表数据");
        this.tableData = [];
        if (res.code == 200) {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.total = res.result.total * 1;
            res.result.list.forEach(item => {
              let object = {};
              object = Object.assign({}, item);
              object.serviceAddressText = item.serviceAddress;
              switch (item.orderStatus) {
                case 1:
                  object.statusText = "待接单";
                  break;
                case 2:
                  object.statusText = "商家已确认";
                  break;
                case 3:
                  object.statusText = "已接单";
                  break;
                case 4:
                  object.statusText = "服务完成";
                  break;
                case 5:
                  object.statusText = "已撤单";
                  break;
                case 6:
                  object.statusText = "到达";
                  break;
                case 7:
                  object.statusText = "服务送达";
                  break;
                case 8:
                  object.statusText = "已评价";
                  break;
              }
              switch (item.orderSource) {
                case 1:
                  object.orderSourceText = "app下单";
                  break;
                case 2:
                  object.orderSourceText = "平台下单";
                  break;
                case 3:
                  object.orderSourceText = "政府下单";
                  break;
              }
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },

    /* 
      获取商品详情
    */
    queryMerchantDetail(orderId) {
      this.$postJson(`omc/serviceOrder/detail/${orderId}`).then(res => {
        if (res.result.itemList) {
          this.goodsItemText = "";
          this.goodsItemPrice = 0;
          res.result.itemList.forEach(item => {
            this.goodsItemText += `${item.name}*${item.number}*${item.price}元；`;
            this.goodsItemPrice += item.price * item.number * 1;
          });
        }
      });
    },

    /* 
      获取商家id
    */
    queryMerchantId() {
      this.$postJson("uac/merchant/haveId").then(res => {
        console.log(res, "查询商家id");
        this.merchantId = res.result;
        this.queryList();
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.queryList(); //刷新列表的数据
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryList(); //刷新列表的数据
    },

    /* 
      表格头部的样式
    */
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #CCCCCC;";
      }
    },
    
    // 处理下拉框滑动问题
    handleVisibleChange(visible){
      let main = document.getElementsByClassName('el-main')
      let dropdown = document.getElementsByClassName('el-select-dropdown')
      main[0].onscroll = function(e){
        // e.target.scrollTop 滑动高度
        for(let i = 0; i < dropdown.length; i++){
          dropdown[i].style.display = 'none'
        }
      }
    }
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  mounted() {
    this.queryMerchantId();
    this.$bus.$on("change_BusinessWorkOrder", () => {
      console.log("刷新商家订单的数据");
      setTimeout(() => {
        this.queryMerchantId(); //每次收到消息推送就刷新
      }, 500);
    });
  },
  destroyed() {
    this.$bus.$off("change_BusinessWorkOrder"); //销毁
  }
};
</script>
<style lang="scss" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.demo-table-expand .el-form--inline .el-form-item__label {
  float: none;
  display: inline-block;
  color: #99a9bf;
  font-weight: 700;
}
.height40 {
  height: 40px;
  line-height: 40px;
}
.colorBtn {
  background: rgb(165, 72, 241);
  color: #fff;
}

.labelOne {
  display: inline-block;
  width: 100px;
  margin-left: 10px;
  height: 20px;
  line-height: 20px;
  text-align: left;
}
.custom-tree-node-1 {
  display: inline-block;
  margin-left: 20px;
  width: 100px;
  text-align: left;
}
.custom-tree-node-show {
  display: inline-block;
  width: 100px;
  text-align: left;
  margin-left: 50px;
}
::deep .el-tree-node__content {
  height: 40px !important;
}
::deep
  .packagemanagement-tree
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: #fff !important;
  color: #606266 !important;
  border-radius: 5px !important;
}
::deep .packagemanagement-tree .el-checkbox {
  height: 30px;
  line-height: 28px;
}
.oldmanmap {
  margin: 20px 5px;
  border: 1px solid rgb(228, 222, 222);
  .map {
    width: 100%;
    height: 400px;
  }
}
//地图插件·
::deep .BMap_stdMpCtrl {
  top: 50px !important;
}
::deep .citylist_popup_main {
  margin-left: 45px;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::deep.el-dialog-map .el-dialog__body {
  padding: 10px !important;
}
::deep .el-dialog-map {
  .el-input__inner {
    width: 50%;
  }
}
</style>